import {
  afterRenderEffect,
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';
import { TESTIMONIALS } from '@app/config';
import { shuffleArray, Testimonial } from '@app/core';
import { SectionHeaderComponent } from '@app/widgets';
import { TuiCarousel, TuiPagination } from '@taiga-ui/kit';

@Component({
  selector: 'app-testimonials-section',
  imports: [TuiCarousel, SectionHeaderComponent, TuiPagination],
  templateUrl: './testimonials-section.component.html',
  styleUrl: './testimonials-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestimonialsSectionComponent {
  protected readonly duration = signal(0);

  readonly testimonials = input<Testimonial[]>(shuffleArray(TESTIMONIALS));

  protected index = 0;

  constructor() {
    afterRenderEffect(() => {
      this.duration.set(15_000);
    });
  }
}
